module.exports = __webpack_public_path__ + "img/square.18cc186f.png";